<template>
	<div class="btn-group" data-toggle="buttons">
		<button
			class="btn btn-sm"
			@click="$emit('input', 'todos')"
			:class="{ 'btn-success': value == 'todos' }"
		>
			Todos
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'f1')"
			:class="{ 'btn-primary': value == 'f1' }"
		>
			F1
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'f2')"
			:class="{ 'btn-warning': value == 'f2' }"
		>
			F2
		</button>
		<button
			class="btn btn-sm"
			@click="$emit('input', 'f3')"
			:class="{ 'btn-danger': value == 'f3' }"
		>
			F3
		</button>
	</div>
</template>
<script>
	export default {
		props: ['value'],
	};
</script>



// WEBPACK FOOTER //
// src/components/exames_dashboard/components/btn-status-stack.vue